import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

export default function Taskjob() {
  const navigate = useNavigate();
  const { http, user } = AuthUser();
  const [tasks, setTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [departments, setdepartments] = useState([]);
  const [showProductDetails, setShowProductDetails] = useState(false);
  const [loading_ts, setLoadingTS] = useState(false);

  const [formData, setFormData] = useState({
    customer_id: "",
    assigned_by: user.id,
    assigned_to: "",
    assiger_branch: "",
    description: "",
    inout: "",
    priority: "Medium",
    warranty: "Out Of Warranty",
    del_date: "",
    est_time: "1",
    service_amount: "",
    damage_remark: "",
    eng_remark: "",
    product_name: "",
    brand: "",
    model: "",
    power_adapter: "",
    bettery: "2",
    carry_case: "",
    laptop_bag: "",
    completed_on: "",
    type: "",
    status: "Pending",
    target_date: "",
    comp_type: "",
    name: "",
    phone: "",
    email: "",
    address: "",
    customer_name: "",
    // Invoice-related fields
    customer_availability_checked: false,
    location: "",
    when_to_go: "",
    customer_designation: "",
    system_supplied_by: "",
    supplied_year: "",
    who_serviced_before: "",
    is_amc: false,
    recommended_solution: "",
    pricing_type: "Regular",
    quote_details: "",
    invoice_generated: false,
    invoice_who_to_give: "",
    payment_collect_immediate: false,
    message_to_customer: "",
    final_customer_availability_checked: false,
  });

  const initialState = {
    customer_id: "",
    assigned_by: user.id,
    assigned_to: "",
    assiger_branch: "",
    description: "",
    inout: "",
    priority: "Medium",
    warranty: "Out Of Warranty",
    del_date: "",
    est_time: "1",
    eng_remark: "",
    service_amount: "",
    damage_remark: "",
    product_name: "",
    brand: "",
    model: "",
    power_adapter: "",
    bettery: "2",
    carry_case: "",
    laptop_bag: "",
    completed_on: "",
    type: "",
    status: "",
    target_date: "",
    comp_type: "",
    name: "",
    phone: "",
    email: "",
    address: "",
    customer_name: "",
    // Invoice-related fields
    customer_availability_checked: false,
    location: "",
    when_to_go: "",
    customer_designation: "",
    system_supplied_by: "",
    supplied_year: "",
    who_serviced_before: "",
    is_amc: false,
    recommended_solution: "",
    pricing_type: "Regular",
    quote_details: "",
    invoice_generated: false,
    invoice_who_to_give: "",
    payment_collect_immediate: false,
    message_to_customer: "",
    final_customer_availability_checked: false,
  };

  const [departmetsall, setdepartmentsall] = useState([]);
  const [customer, setcustomer] = useState([]);
  const [users, setUsers] = useState([]);
  const [available, setAvailable] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [showAmcDetails, setShowAmcDetails] = useState(false);

  useEffect(() => {
    http.get(`/department_user_company?&login_user=${user.id}`).then((res) => {
      setUsers(res.data.users);
    });
    http.get(`/get_customer`).then((res) => {
      setcustomer(res.data.users);
    });
    fetchTaskDetails();
    http.get(`/branch`).then((res) => {
      setdepartments(res.data.users);
    });
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    if (e.target.name === "assigned_to") {
      fetchCusterAvail(e.target.value);
    }
    if (e.target.name === "comp_type" && e.target.value === "2") {
      setShowProductDetails(true);
    }

    if (e.target.name === "comp_type" && e.target.value === "1") {
      setShowProductDetails(false);
    }

    // Show AMC details only when "OTHER JC" branch is selected
    if (e.target.name === "assiger_branch") {
      const selectedBranch = departments.find(dept => dept.id == e.target.value);
      if (selectedBranch && selectedBranch.branch_name === "OTHER JC") {
        setShowAmcDetails(true);
      } else {
        setShowAmcDetails(false);
      }
    }
  };

  const fetchCusterAvail = async (custId) => {
    try {
      const response = await http.get(
        `/cust_available?cust_id=${custId}&login_user=${user.id}`
      );
      setAvailable(response.data.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingTS(1);
    const form = new FormData();
    for (const key in formData) {
      form.append(key, formData[key]);
    }
    try {
      http
        .post("/tasksjob", form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          toast.success("Task added successfully !");
          setFormData(initialState);
          setLoadingTS(false);
          navigate("/jobcart/dashboard-job");
        });
    } catch (error) {
      console.error("Error adding task:", error.response.data);
    }
  };

  const options = customer.map((user) => ({
    value: user.id,
    label: `${user.name} - ${user.phone} - ${user.company}`,
  }));

  const [showModalRevise, setShowModalRevise] = useState(false);

  const openModalRevise = () => {
    setShowModalRevise(true);
  };
  const closeModal = () => {
    setShowModalRevise(false);
  };

  const fetchTaskDetails = () => {
    setIsLoading(true);
    let endpoint = `/cust_available_total?login_user=${user.id}`;

    http
      .get(endpoint)
      .then((res) => {
        setIsLoading(false);
        if (Array.isArray(res.data.data)) {
          setTasks(res.data.data);
        } else {
          setIsLoading(false);
          console.error("API response is not an array");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });
  };
  const submitButtonText = loading_ts ? "Submitting..." : "Add Job Card";

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();

    // Pad single-digit months and days with a leading zero
    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;

    return `${year}-${month}-${day}`;
  };
  const [minDate, setMinDate] = useState(getCurrentDate());

  return (
    <>
      <>
        {showModalRevise && (
          <div className="modal" tabIndex="-1" style={{ display: "block" }}>
            <div className="modal-dialog modal-lg">
              <form onSubmit={handleSubmit}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Work status Details</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={closeModal}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <table className="table table-striped">
                      <thead className="table-primary">
                        <tr>
                          <th className="text-danger">No</th>
                          <th>Name</th>
                          <th>Total Time</th>
                          <th>Total Analitics</th>
                          <th>Today</th>
                          <th>Tomorrow</th>
                          <th>Day-after</th>
                          {/* Add other fields as necessary */}
                        </tr>
                      </thead>
                      <tbody>
                        {tasks.map((taskuser, index) => (
                          <tr key={taskuser.id}>
                            <td>{index + 1}</td>
                            <td className="text-uppercase">
                              {taskuser.name} {taskuser.last_name}
                            </td>
                            <td>
                              <b>{taskuser.total_est_time}</b> Hours
                            </td>
                            <td width="17%">
                              <div className="progress">
                                <div
                                  className="progress-bar"
                                  role="progressbar"
                                  style={{ width: `${taskuser.percentage}%` }}
                                  aria-valuenow={taskuser.percentage}
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                >
                                  {taskuser.percentage}%
                                </div>
                              </div>
                            </td>
                            {/* Today logic */}
                            <td width="17%">
                              <div className="progress">
                                <div
                                  className="progress-bar"
                                  role="progressbar"
                                  style={{
                                    width: `${taskuser.today_percentage}%`,
                                  }}
                                  aria-valuenow={taskuser.today_percentage}
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                >
                                  {taskuser.today_percentage}%
                                </div>
                              </div>
                              <div className="row">
                                <span className="text-center col-12">
                                  <b>{taskuser.today_est_time} Hrss</b>
                                </span>
                              </div>
                            </td>
                            {/* Tommorrw logic */}
                            <td width="17%">
                              <div className="progress">
                                <div
                                  className="progress-bar"
                                  role="progressbar"
                                  style={{
                                    width: `${taskuser.tommorrow_percentage}%`,
                                  }}
                                  aria-valuenow={taskuser.tommorrow_percentage}
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                >
                                  {taskuser.tommorrow_percentage}%
                                </div>
                              </div>
                              <div className="row">
                                <span className="text-center col-12">
                                  <b>{taskuser.tommorrow_est_time} Hr</b>
                                </span>
                              </div>
                            </td>

                            {/* Dayafter logic */}
                            <td width="17%">
                              <div className="progress">
                                <div
                                  className="progress-bar"
                                  role="progressbar"
                                  style={{
                                    width: `${taskuser.dayafter_percentage}%`,
                                  }}
                                  aria-valuenow={taskuser.dayafter_percentage}
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                >
                                  {taskuser.dayafter_percentage}%
                                </div>
                              </div>
                              <div className="row">
                                <span className="text-center col-12">
                                  <b>{taskuser.dayafter_est_time} Hr</b>
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn-sm btn btn-success"
                      onClick={closeModal}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
        <div className="container mt-5">
          <Toaster />
          <h1>Add Job Card</h1>
          <a
            href="#"
            className="text-end btn-link"
            onClick={() => openModalRevise()}
          >
            Analitics 📊
          </a>
          <form onSubmit={handleSubmit} className="row">
            <div className="col-md-6 border p-3 rounded-3 mx-4">

              <div className="form-group mt-3 border p-2 border-success rounded">
                <label>Branch</label>
                <select
                  onChange={handleChange}
                  name="assiger_branch"
                  className="form-control mb-1"
                  required
                >
                  <option value="">Select Branch</option>
                  {departments.map((dept, index) => (
                    <option key={index} value={dept.id}>
                      {dept.branch_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group  mt-3">
                <label>Type</label>
                <select
                  name="comp_type"
                  className="form-control text-uppercase"
                  value={formData.comp_type}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Type</option>
                  <option value="2">Walk In (New) </option>
                  <option value="1">Exist Company</option>
                </select>
              </div>
              {showProductDetails && (
                <div className="border border-warning p-2 mt-2 rounded">
                  <div className="form-group mt-3">
                    <label>Person Name</label>

                    <input
                      name="name"
                      className="form-control"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group mt-3">
                    <label>Phone</label>

                    <input
                      name="phone"
                      className="form-control"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group mt-3">
                    <label>Email</label>

                    <input
                      name="email"
                      className="form-control"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group mt-3">
                    <label>Location</label>

                    <input
                      name="address"
                      className="form-control"
                      value={formData.address}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              )}
              {!showProductDetails && (
                <div className="form-group mt-3">
                  <label>Customer</label>

                  <Select
                    options={options}
                    name="customer_id"
                    value={options.find(
                      (option) => option.value === formData.customer_id
                    )}
                    onChange={(selectedOption) =>
                      setFormData({
                        ...formData,
                        customer_id: selectedOption.value,
                        customer_name: selectedOption.label,
                      })
                    }
                  />
                </div>
              )}
              <div className="form-group  mt-3">
                <label>Assigned To</label>
                <select
                  name="assigned_to"
                  className="form-control text-uppercase"
                  value={formData.assigned_to}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a user</option>
                  {users.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.name} {user.last_name}
                    </option>
                  ))}
                </select>
              </div>
              {available && (
                <div className="border border-warning mt-3 p-3 rounded">
                  <div className="form-group  mt-3 ">
                    <label className="text-danger px-2">
                      Total Time Occupied :{" "}
                    </label>
                    <span class="badge bg-success">
                      {available.est_time_sum == 0
                        ? "Fully available"
                        : available.est_time_sum + " Hours"}{" "}
                    </span>
                  </div>

                  <div className="progress  mt-2">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: `${available.percentage}%` }}
                      aria-valuenow={available.percentage}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {available.percentage}%
                    </div>
                  </div>
                </div>
              )}



              <div className="form-group  mt-2">
                <label>Establish Time</label>
                <select
                  name="est_time"
                  onChange={handleChange}
                  className="form-control"
                  value={formData.est_time}
                  required
                >
                  <option value="0">0 Hour</option>
                  <option value="1">1 Hour</option>
                  <option value="2">2 Hour</option>
                  <option value="3">3 Hour</option>
                  <option value="4">4 Hour-Half day</option>
                  <option value="5">5 Hour</option>
                  <option value="6">6 Hour</option>
                  <option value="7">7 Hour</option>
                  <option value="8">8 Hour</option>
                </select>
              </div>

              <div className="form-group mt-3">
                <label>Problem & Description</label>
                <textarea
                  name="description"
                  className="form-control"
                  value={formData.description}
                  onChange={handleChange}
                  rows="2"
                  required
                />
              </div>

              <div className="form-group mt-3">
                <label>InSide/Outside</label>
                <select
                  name="inout"
                  className="form-control"
                  value={formData.inout}
                  onChange={handleChange}
                  required
                >
                  <option value="1">Inside</option>
                  <option value="2">Outside</option>
                </select>
              </div>

              <div className="form-group  mt-2">
                <label>Tentative Delivery Date</label>
                <input
                  name="del_date"
                  className="form-control"
                  type="date"
                  value={formData.del_date}
                  onChange={handleChange}

                />
              </div>

              <div className="form-group  mt-2">
                <label>Target Date</label>
                <input
                  name="target_date"
                  className="form-control"
                  type="date"
                  value={formData.target_date}
                  onChange={handleChange}
                  min={minDate}
                  required
                />
              </div>

              <div className="form-group  mt-2">
                <label>Warranty Detail</label>
                <select
                  className="form-control"
                  onChange={handleChange}
                  name="warranty"
                >
                  <option value="Out Of Warranty">Out Of Warranty</option>
                  <option value="Under Warranty">Under Warranty</option>
                </select>
              </div>

              <div className="form-group mt-3">
                <label>Priority</label>
                <select
                  name="priority"
                  className="form-control"
                  value={formData.priority}
                  onChange={handleChange}
                  required
                >
                  <option value="High">High</option>
                  <option value="Medium">Medium</option>
                  <option value="Low">Low</option>
                </select>
              </div>

              <div className="form-group  mt-2">
                <label>Service Amount</label>
                <input
                  name="service_amount"
                  onChange={handleChange}
                  value={formData.service_amount}
                  className="form-control"
                  type="number"

                />
              </div>

              <div className="form-group  mt-2">
                <label>Engineer Remark</label>
                <input
                  name="eng_remark"
                  onChange={handleChange}
                  value={formData.eng_remark}
                  className="form-control"
                  type="text"

                />
              </div>

              <div className="form-group  mt-2">
                <label>Damage Remark</label>
                <input
                  name="damage_remark"
                  onChange={handleChange}
                  value={formData.damage_remark}
                  className="form-control"
                  type="text"
                />
              </div>
            </div>

            <div className="col-md-5 border p-3 rounded-3">
              <h1>Product Details</h1>
              <div className="form-group  mt-2">
                <label>Product Name</label>
                <input
                  name="product_name"
                  className="form-control"
                  onChange={handleChange}
                  value={formData.product_name}
                  type="text"
                  required
                />
              </div>

              <div className="form-group  mt-2">
                <label>Others</label>
                <input
                  name="brand"
                  className="form-control"
                  onChange={handleChange}
                  value={formData.brand}
                  type="text"
                />
              </div>

              <div className="form-group  mt-2">
                <label>Model</label>
                <input
                  name="model"
                  className="form-control"
                  onChange={handleChange}
                  value={formData.model}
                  type="text"
                />
              </div>

              <div className="form-group  mt-2">
                <label>Product Password</label>
                <input
                  name="type"
                  className="form-control"
                  onChange={handleChange}
                  value={formData.type}
                  type="text"
                  required
                />
              </div>

              <div className="form-group mt-3">
                <label htmlFor="view_branch">Product Attributes</label>

                <div className="form-group mt-3">
                  <label>Power adapter</label>
                  <select
                    name="power_adapter"
                    className="form-control"
                    onChange={handleChange}
                    value={formData.power_adapter}
                    required
                  >
                    <option value="">Select Any</option>
                    <option value="1">Yes</option>
                    <option value="2">No</option>
                  </select>
                </div>

                {/* <div className="form-group mt-3">
                  <label htmlFor="k2">Bettery</label>
                  <select
                    name="bettery"
                    className="form-control"
                    onChange={handleChange}
                    value={formData.bettery}
                    
                  >
                    <option value="">Select Any</option>
                    <option value="1">Yes</option>
                    <option value="2">No</option>
                  </select>
                </div> */}

                <div className="form-group mt-3">
                  <label htmlFor="k2">Antivirus Required ?</label>
                  <select
                    name="carry_case"
                    className="form-control"
                    onChange={handleChange}
                    value={formData.carry_case}
                    required
                  >
                    <option value="">Select Any</option>
                    <option value="1">Yes</option>
                    <option value="2">No</option>
                  </select>
                </div>

                <div className="form-group mt-3">
                  <label htmlFor="k2">Laptop Bag</label>
                  <select
                    name="laptop_bag"
                    className="form-control"
                    onChange={handleChange}
                    value={formData.laptop_bag}
                    required
                  >
                    <option value="">Select Any</option>
                    <option value="1">Yes</option>
                    <option value="2">No</option>
                  </select>
                </div>
              </div>
            </div>

            {/* AMC Job Card Details Section - Only show when "OTHER JC" branch is selected */}
            {showAmcDetails && (
              <div className="col-md-12 mt-4">
                <div className="invoice-fields-container">
                <div className="invoice-header bg-gradient border border-2 border-primary rounded-3 p-3 mb-4">
                  <h4 className="text-center text-white mb-0 fw-bold">
                    🏢 AMC Job Card Details
                  </h4>
                </div>

                <div className="row">
                  {/* Customer Availability and Date/Assigned To */}
                  <div className="col-md-6 mb-3">
                    <div className="modern-card p-3">
                      <label className="form-label fw-bold text-primary">✅ Customer Availability Checked:</label>
                      <div className="modern-radio-group">
                        <div className="form-check form-check-inline">
                          <input 
                            className="form-check-input modern-radio" 
                            type="radio" 
                            name="customer_availability_checked" 
                            checked={formData.customer_availability_checked === true}
                            onChange={() => setFormData({...formData, customer_availability_checked: true})}
                          />
                          <label className="form-check-label modern-label">✅ Yes</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input 
                            className="form-check-input modern-radio" 
                            type="radio" 
                            name="customer_availability_checked" 
                            checked={formData.customer_availability_checked === false}
                            onChange={() => setFormData({...formData, customer_availability_checked: false})}
                          />
                          <label className="form-check-label modern-label">❌ No</label>
                        </div>
                      </div>
                    </div>
                  </div>




                  {/* Location and When to Go */}
                  <div className="col-md-6 mb-3">
                    <div className="modern-card p-3">
                      <label className="form-label fw-bold text-primary">📍 Location:</label>
                      <input
                        type="text"
                        name="location"
                        className="form-control modern-input"
                        value={formData.location}
                        onChange={handleChange}
                        placeholder="Enter location"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="modern-card p-3">
                      <label className="form-label fw-bold text-primary">⏰ When to GO / Time:</label>
                      <input
                        type="text"
                        name="when_to_go"
                        className="form-control modern-input"
                        value={formData.when_to_go}
                        onChange={handleChange}
                        placeholder="Enter time"
                      />
                    </div>
                  </div>



                  {/* Customer Designation */}
                  <div className="col-md-6 mb-3">
                    <div className="modern-card p-3">
                      <label className="form-label fw-bold text-primary">💼 Who is he | Designation or Dept:</label>
                      <input
                        type="text"
                        name="customer_designation"
                        className="form-control modern-input"
                        value={formData.customer_designation}
                        onChange={handleChange}
                        placeholder="Enter designation"
                      />
                    </div>
                  </div>



                  {/* System Details */}
                  <div className="col-md-6 mb-3">
                    <div className="modern-card p-3">
                      <label className="form-label fw-bold text-primary">🏭 System Supplied by Whom:</label>
                      <input
                        type="text"
                        name="system_supplied_by"
                        className="form-control modern-input"
                        value={formData.system_supplied_by}
                        onChange={handleChange}
                        placeholder="Enter supplier"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="modern-card p-3">
                      <label className="form-label fw-bold text-primary">📅 Appx when supplied (Year):</label>
                      <input
                        type="text"
                        name="supplied_year"
                        className="form-control modern-input"
                        value={formData.supplied_year}
                        onChange={handleChange}
                        placeholder="Enter year"
                      />
                    </div>
                  </div>

                  {/* Who Serviced Before and Urgency/AMC */}
                  <div className="col-md-6 mb-3">
                    <div className="modern-card p-3">
                      <label className="form-label fw-bold text-primary">🔧 Who Serviced before from Katze:</label>
                      <input
                        type="text"
                        name="who_serviced_before"
                        className="form-control modern-input"
                        value={formData.who_serviced_before}
                        onChange={handleChange}
                        placeholder="Enter name"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="modern-card p-3">
                      <div className="row">

                        <div className="col-md-6">
                          <label className="form-label fw-bold text-primary">🔧 AMC:</label>
                          <div className="modern-radio-group">
                            <div className="form-check">
                              <input 
                                className="form-check-input" 
                                type="radio" 
                                name="is_amc" 
                                checked={formData.is_amc === true}
                                onChange={() => setFormData({...formData, is_amc: true})}
                              />
                              <label className="form-check-label">YES</label>
                            </div>
                            <div className="form-check">
                              <input 
                                className="form-check-input" 
                                type="radio" 
                                name="is_amc" 
                                checked={formData.is_amc === false}
                                onChange={() => setFormData({...formData, is_amc: false})}
                              />
                              <label className="form-check-label">NO</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Recommended Solution */}
                  <div className="col-md-12 mb-3">
                    <div className="modern-card p-3">
                      <label className="form-label fw-bold text-primary">💡 Recommended Solution:</label>
                      <input
                        type="text"
                        name="recommended_solution"
                        className="form-control modern-input"
                        value={formData.recommended_solution}
                        onChange={handleChange}
                        placeholder="Enter recommended solution"
                      />
                    </div>
                  </div>

                  {/* Pricing Options */}
                  <div className="col-md-12 mb-3">
                    <div className="pricing-card modern-card border border-2 border-primary rounded-3 p-3">
                      <h5 className="fw-bold mb-3 text-primary d-flex align-items-center">
                        💰 Pricing Options
                      </h5>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="pricing-options">
                            <div className="form-check pricing-option">
                              <input 
                                className="form-check-input modern-radio" 
                                type="radio" 
                                name="pricing_type" 
                                checked={formData.pricing_type === "Regular"}
                                onChange={() => setFormData({...formData, pricing_type: "Regular"})}
                              />
                              <label className="form-check-label pricing-label">
                                <span className="pricing-icon">📊</span> Regular Pricing
                              </label>
                            </div>
                            <div className="form-check pricing-option">
                              <input 
                                className="form-check-input modern-radio" 
                                type="radio" 
                                name="pricing_type" 
                                checked={formData.pricing_type === "Customized"}
                                onChange={() => setFormData({...formData, pricing_type: "Customized"})}
                              />
                              <label className="form-check-label pricing-label">
                                <span className="pricing-icon">⚙️</span> Customized Pricing
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Charges and Quote */}
                  <div className="col-md-6 mb-3">
                    <div className="modern-card p-3">
                      <label className="form-label fw-bold text-primary">💵 Charges Amount:</label>
                      <input
                        type="number"
                        name="charges_amount"
                        className="form-control modern-input"
                        value={formData.charges_amount}
                        onChange={handleChange}
                        placeholder="Enter amount"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="modern-card p-3">
                      <label className="form-label fw-bold text-primary">📋 Quote Submit:</label>
                      <input
                        type="text"
                        name="quote_details"
                        className="form-control modern-input"
                        value={formData.quote_details}
                        onChange={handleChange}
                        placeholder="Enter quote details"
                      />
                    </div>
                  </div>

                  {/* Invoice Details */}
                  <div className="col-md-6 mb-3">
                    <div className="modern-card p-3">
                      <label className="form-label fw-bold text-primary">📄 Invoice generated or not:</label>
                      <select
                        name="invoice_generated"
                        className="form-control modern-input"
                        value={formData.invoice_generated}
                        onChange={handleChange}
                      >
                        <option value={false}>Not Generated</option>
                        <option value={true}>Generated</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="modern-card p-3">
                      <label className="form-label fw-bold text-primary">👤 Invoice whom to give:</label>
                      <input
                        type="text"
                        name="invoice_who_to_give"
                        className="form-control modern-input"
                        value={formData.invoice_who_to_give}
                        onChange={handleChange}
                        placeholder="Enter recipient"
                      />
                    </div>
                  </div>

                  {/* Payment and JC Created By */}
                  <div className="col-md-6 mb-3">
                    <div className="modern-card p-3">
                      <label className="form-label fw-bold text-primary">💳 Payment Collect immediate / Credit:</label>
                      <select
                        name="payment_collect_immediate"
                        className="form-control modern-input"
                        value={formData.payment_collect_immediate}
                        onChange={handleChange}
                      >
                        <option value={false}>Credit</option>
                        <option value={true}>Immediate</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="modern-card p-3">
                      <label className="form-label fw-bold text-primary">👨‍💼 JC Created by:</label>
                      <input
                        type="text"
                        name="jc_created_by"
                        className="form-control modern-input"
                        value={formData.jc_created_by}
                        onChange={handleChange}
                        placeholder="Enter creator name"
                      />
                    </div>
                  </div>

                  {/* Customer Communication */}
                  <div className="col-md-12 mb-3">
                    <div className="message-card modern-card border border-2 border-success rounded-3 p-3">
                      <h5 className="fw-bold mb-3 text-success d-flex align-items-center">
                        💬 Customer Communication
                      </h5>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <label className="form-label fw-bold text-success">Message to Customer:</label>
                          <input 
                            type="text" 
                            name="message_to_customer"
                            className="form-control modern-input"
                            value={formData.message_to_customer}
                            onChange={handleChange}
                            placeholder="Enter message for customer"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label fw-bold text-success mb-2">Final Availability Check:</label>
                          <div className="modern-radio-group">
                            <div className="form-check form-check-inline">
                              <input 
                                className="form-check-input modern-radio" 
                                type="radio" 
                                name="final_customer_availability_checked" 
                                checked={formData.final_customer_availability_checked === true}
                                onChange={() => setFormData({...formData, final_customer_availability_checked: true})}
                              />
                              <label className="form-check-label modern-label">✅ Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input 
                                className="form-check-input modern-radio" 
                                type="radio" 
                                name="final_customer_availability_checked" 
                                checked={formData.final_customer_availability_checked === false}
                                onChange={() => setFormData({...formData, final_customer_availability_checked: false})}
                              />
                              <label className="form-check-label modern-label">❌ No</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            )}

            <button
              className="btn button btn-success mt-3 mb-2"
              type="submit"
              disabled={loading_ts}
            >
              {submitButtonText}
            </button>
          </form>
        </div>
      </>

      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        
        .invoice-fields-container {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%);
          border-radius: 25px;
          padding: 30px;
          border: 2px solid #e2e8f0;
          box-shadow: 0 20px 60px rgba(148, 163, 184, 0.15);
          position: relative;
          overflow: hidden;
          animation: slideInUp 0.8s ease-out;
        }

        .invoice-fields-container::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(71,85,105,0.05)"/><circle cx="75" cy="75" r="1" fill="rgba(71,85,105,0.05)"/><circle cx="50" cy="10" r="0.5" fill="rgba(71,85,105,0.03)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
          pointer-events: none;
        }

        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes glow {
          0%, 100% { box-shadow: 0 0 20px rgba(59, 130, 246, 0.2); }
          50% { box-shadow: 0 0 30px rgba(59, 130, 246, 0.3); }
        }

        .invoice-header {
          background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%) !important;
          box-shadow: 0 15px 35px rgba(59, 130, 246, 0.2);
          border-radius: 20px !important;
          position: relative;
          overflow: hidden;
          animation: glow 3s ease-in-out infinite;
        }

        .invoice-header::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: linear-gradient(45deg, transparent, rgba(255,255,255,0.2), transparent);
          animation: shimmer 3s linear infinite;
        }

        @keyframes shimmer {
          0% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
          100% { transform: translateX(100%) translateY(100%) rotate(45deg); }
        }

        .invoice-header h4 {
          position: relative;
          z-index: 2;
          text-shadow: 0 2px 4px rgba(0,0,0,0.3);
          font-family: 'Inter', sans-serif;
          font-weight: 700;
          letter-spacing: 1px;
        }

        .modern-card {
          background: linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.98) 100%);
          border: 1px solid rgba(226, 232, 240, 0.8);
          border-radius: 20px;
          box-shadow: 0 10px 40px rgba(71, 85, 105, 0.08);
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          position: relative;
          overflow: hidden;
          height: 100%;
          backdrop-filter: blur(10px);
        }

        .modern-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 4px;
          background: linear-gradient(90deg, #3b82f6, #10b981, #06b6d4, #8b5cf6, #f59e0b);
          background-size: 300% 100%;
          animation: gradientMove 3s ease infinite;
        }

        @keyframes gradientMove {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }

        .modern-card:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 20px 60px rgba(71, 85, 105, 0.12);
          background: linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(248,250,252,1) 100%);
        }

        .modern-input {
          border: 2px solid rgba(148, 163, 184, 0.3);
          border-radius: 15px;
          padding: 15px 20px;
          font-size: 14px;
          font-family: 'Inter', sans-serif;
          font-weight: 500;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(5px);
          position: relative;
          color: #334155;
        }

        .modern-input:focus {
          border-color: #3b82f6;
          box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1), 0 8px 25px rgba(59, 130, 246, 0.08);
          transform: translateY(-2px);
          outline: none;
          background: rgba(255, 255, 255, 1);
        }

        .modern-input::placeholder {
          color: rgba(100, 116, 139, 0.6);
          font-style: italic;
        }

        .form-label {
          font-size: 15px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          gap: 8px;
          font-family: 'Inter', sans-serif;
          font-weight: 600;
          color: #2d3748;
          text-shadow: 0 1px 2px rgba(0,0,0,0.1);
        }

        .text-primary {
          background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .fw-bold {
          font-weight: 700 !important;
        }

        .border-2 {
          border-width: 3px !important;
        }

        .bg-gradient {
          background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        }

        .text-white {
          color: white !important;
        }

        .text-center {
          text-align: center;
        }

        .mb-0 {
          margin-bottom: 0 !important;
        }

        .p-3 {
          padding: 1.5rem !important;
        }

        .mb-3 {
          margin-bottom: 1.5rem !important;
        }

        .mb-4 {
          margin-bottom: 2rem !important;
        }

        .mt-4 {
          margin-top: 2rem !important;
        }

        .rounded-3 {
          border-radius: 1rem !important;
        }

        .border-primary {
          border-color: #3b82f6 !important;
        }

        .modern-radio-group {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .modern-radio-group .form-check-inline {
          margin-right: 20px;
          padding: 8px 15px;
          border-radius: 25px;
          transition: all 0.3s ease;
          background: rgba(59, 130, 246, 0.05);
        }

        .modern-radio-group .form-check-inline:hover {
          background: rgba(59, 130, 246, 0.1);
          transform: translateX(3px);
        }

        .modern-radio {
          width: 20px;
          height: 20px;
          margin-right: 10px;
          border: 2px solid #3b82f6;
        }

        .modern-radio:checked {
          background-color: #3b82f6;
          border-color: #3b82f6;
          box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
          animation: pulse 0.6s ease-in-out;
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        .modern-label {
          font-weight: 500;
          color: #475569;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .modern-label:hover {
          color: #3b82f6;
        }

        .pricing-card {
          background: linear-gradient(135deg, rgba(59,130,246,0.05) 0%, rgba(16,185,129,0.05) 50%, rgba(6,182,212,0.05) 100%);
          border: 2px solid rgba(148, 163, 184, 0.2);
          background-clip: padding-box;
          position: relative;
        }

        .pricing-options {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .pricing-option {
          margin-bottom: 20px;
          padding: 20px;
          border: 2px solid rgba(148, 163, 184, 0.2);
          border-radius: 15px;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          cursor: pointer;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          position: relative;
          overflow: hidden;
        }

        .pricing-option:hover {
          border-color: #3b82f6;
          background: rgba(59, 130, 246, 0.05);
          transform: translateX(8px) scale(1.02);
          box-shadow: 0 10px 30px rgba(59, 130, 246, 0.15);
        }

        .pricing-option input:checked + .pricing-label {
          color: #3b82f6;
          font-weight: 700;
        }

        .pricing-label {
          display: flex;
          align-items: center;
          margin-bottom: 0;
          font-size: 16px;
          font-weight: 600;
          position: relative;
          z-index: 2;
        }

        .pricing-icon {
          margin-right: 12px;
          font-size: 24px;
          animation: bounce 2s infinite;
        }

        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-5px); }
          60% { transform: translateY(-3px); }
        }

        .message-card {
          background: linear-gradient(135deg, rgba(40, 167, 69, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%);
          border: 2px solid rgba(40, 167, 69, 0.3);
          position: relative;
          overflow: hidden;
        }

        .text-success {
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .border-success {
          border-color: #28a745 !important;
        }

        .g-3 > * {
          padding: 1rem;
        }

        /* Improved typography */
        * {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }
      `}</style>
    </>
  );
}
